let globalObserver = null;

export function lazyLoadImages(selector = 'img.lazy-image', options = { threshold: 0.5 }) {
    if (typeof window === 'undefined') return;

    if (!globalObserver) {
        globalObserver = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const img = entry.target;
                    if (img.dataset.srcset) {
                        img.srcset = img.dataset.srcset;
                    }
                    img.src = img.dataset.src;
                    img.classList.remove('lazy-image');
                    observer.unobserve(img);
                }
            });
        }, options);
    }

    const images = document.querySelectorAll(`${selector}[data-src]`);
    images.forEach(image => {
        globalObserver.observe(image);
    });

    return globalObserver;
}

// Auto-initialize on DOM ready
if (typeof window !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => lazyLoadImages());
    } else {
        lazyLoadImages();
    }
}

// Expose globally for dynamic content
if (typeof window !== 'undefined') {
    window.lazyLoadImages = lazyLoadImages;
}